export default __webpack_public_path__ + "static/media/dgl-ipad.4434c694.png";